import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './Header.scss';
import { useAuth } from "../../security/AuthContext"; // Custom CSS for header styles

const Header: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const currentTab = location.pathname.split('/')[1];
  const previousPath = location.state?.from || '/';
  const tabNames: { [key: string]: string } = {
    'agents': 'AI Agents',
    'conversations': 'Conversations',
    'customers': 'Customers',
    'integrations': 'Integrations',
  };

  const { logout } = useAuth();

  return (
    <header className="header">
      <div className="header-content">
        {!!currentTab && (
          <button className="back-button" onClick={() => navigate(previousPath)}>
            ← Back
          </button>
        )}
        <h1>{tabNames[currentTab]}</h1>
        <button className="logout-button" onClick={logout}>
          Logout
        </button>
      </div>
    </header>
  );
};

export default Header;
